import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useLogin } from '../../context/LoginContext';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const { isLoggedIn, logout,user } = useLogin();
    const navigate = useNavigate();
    const handelhome = (e) => {
      isLoggedIn ? navigate('/home') : logout(() => navigate('/'));
  }
  return (
    <Container fluid className="d-flex vh-100 align-items-center justify-content-center bg-light">
      <Row className="w-100 justify-content-center">
        <Col md={6} className="text-center">
          <h1 className="display-1 fw-bold text-danger">404</h1>
          <h3 className="fw-bold mb-3">Page Not Found</h3>
          <p className="mb-4 text-secondary">
            Sorry, the page you are looking for does not exist or has been moved.
          </p>
          <Button variant="primary" onClick={handelhome} className="mt-3">
            Go to Home
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default NotFound;